
export const getUniqueVariantsByVisualValue = (variants: Array<GQL.IProductVariant>) => {
    const uniqueVariants = new Array<GQL.IProductVariant>();

    for (const variant of variants) {
        uniqueVariants.push(variant);

        // todo: vizuální atributy už se moc nepoužívají

        // const variantVisualValues = (variant.attributeValues || []).filter(v => v.attribute.isVisual);
        // if (variantVisualValues.length > 0) {
        //     const value = variantVisualValues[0];
        //     if (uniqueVariants.some(v => (v.attributeValues ||[]).some(a => a.id == value.id))) {
        //         // do nothin
        //     } else {
        //         uniqueVariants.push(variant);
        //     }
        // }
    }

    if (uniqueVariants.length === 0 && variants.length > 0) {
        uniqueVariants.push(variants[0]);
    }

    return uniqueVariants;
}



// WEBPACK FOOTER //
// ./src/helpers/Variants/getUniqueVariantsByVisualValue.ts